"use strict";
/**
 * @file Created on Tue Mar 17 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var ValidationResultConverter_1 = require("../../core/model/errors/conversions/ValidationResultConverter");

var ForecastSimulationSaveResultDTO_1 = require("../model/ForecastSimulationSaveResultDTO");

var ForecastSimulationConflictDTOConverter_1 = require("./ForecastSimulationConflictDTOConverter");

var ForecastSimulationSaveResultDTOConverter_1 = require("./ForecastSimulationSaveResultDTOConverter");
/**
 * @author Tomas Leity
 */


var ForecastSimulationSaveResultDTOConverterImpl =
/*#__PURE__*/
function (_ForecastSimulationSa) {
  _inherits(ForecastSimulationSaveResultDTOConverterImpl, _ForecastSimulationSa);

  function ForecastSimulationSaveResultDTOConverterImpl(simulationConflictDTOConverter, validationResultConverter) {
    var _this;

    _classCallCheck(this, ForecastSimulationSaveResultDTOConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ForecastSimulationSaveResultDTOConverterImpl).call(this));
    _this.simulationConflictDTOConverter = simulationConflictDTOConverter;
    _this.validationResultConverter = validationResultConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ForecastSimulationSaveResultDTOConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new ForecastSimulationSaveResultDTO_1.ForecastSimulationSaveResultDTO(conversions.asObjectOpt(source, 'conflicts', function (doc) {
        return _this2.simulationConflictDTOConverter.toObject(doc, conversions);
      }), conversions.asObjectOpt(source, 'validationResult', function (doc) {
        return _this2.validationResultConverter.toObject(doc, conversions);
      }));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      return {
        conflicts: conversions.asObjectOpt(source, 'conflicts', function (dto) {
          return _this3.simulationConflictDTOConverter.toDocument(dto, conversions);
        }),
        validationResult: conversions.asObjectOpt(source, 'validationResult', function (dto) {
          return _this3.validationResultConverter.toDocument(dto, conversions);
        })
      };
    }
  }]);

  return ForecastSimulationSaveResultDTOConverterImpl;
}(ForecastSimulationSaveResultDTOConverter_1.ForecastSimulationSaveResultDTOConverter);

ForecastSimulationSaveResultDTOConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __param(1, typescript_ioc_1.Inject), __metadata("design:paramtypes", [ForecastSimulationConflictDTOConverter_1.ForecastSimulationConflictDTOConverter, ValidationResultConverter_1.ValidationResultConverter])], ForecastSimulationSaveResultDTOConverterImpl);
exports.ForecastSimulationSaveResultDTOConverterImpl = ForecastSimulationSaveResultDTOConverterImpl;